// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tox-collection__item-label {
  margin-left: 0px !important;
}

.tox-collection__item-checkmark {
  display: none !important;
}

.tox-menu {
  min-width: 57px !important;
}

.tox .tox-dialog-wrap {
  z-index: 99 !important;
}

.tox-tinymce-aux {
  z-index: 99 !important;
}

.tox-icon svg {
  scale: 0.9;
  transform-origin: center;
}`, "",{"version":3,"sources":["webpack://./src/components/TinyMceEditor/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":[".tox-collection__item-label {\n  margin-left: 0px !important;\n}\n\n.tox-collection__item-checkmark {\n  display: none !important;\n}\n\n.tox-menu {\n  min-width: 57px !important;\n}\n\n.tox .tox-dialog-wrap {\n  z-index: 99 !important;\n}\n\n.tox-tinymce-aux {\n  z-index: 99 !important;\n}\n\n.tox-icon svg {\n  scale: 0.9;\n  transform-origin: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
